export default __webpack_public_path__ + "static/media/0373.a6ce995c.jpg";